import type { Id } from 'api/models';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import Amount from 'shared/components/Amount';
import { Icon, IconName } from 'shared/components/Icon';
import type { ReconciliationInvoice } from 'types/store/transaction-state';
import classes from './InvoiceTableItem.module.css';

interface InvoiceTableItemProps {
  item: ReconciliationInvoice;
  amounts: Record<Id, string>;
  disableButtons: boolean;
  handleSetAmount: (id: Id, amount: string) => void;
}

export const InvoiceTableItem = ({
  item,
  amounts,
  disableButtons,
  handleSetAmount,
}: InvoiceTableItemProps) => {
  const {
    id,
    reference,
    issue_date: issueDate,
    remaining_balance: remainingBalance,
    remaining_late_fees: remainingFees,
    currency,
    localized_money_object: {
      remaining_balance: remainingBalanceLocalized,
      remaining_late_fees: remainingFeesLocalized,
    },
  } = item;

  const amount = amounts[id];

  const isRemainingBalanceSaturated = Number(amount) >= remainingBalance;
  const isRemainingBalanceWithFeesSaturated =
    Number(amount) === Number(remainingBalance) + Number(remainingFees);

  return (
    <tr>
      <td>
        <Link to={`/invoices/${id}`} target="_blank">
          {reference}
        </Link>
      </td>
      <td>{dayjs(issueDate).format('L')}</td>
      <td>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Amount
            style={{ display: 'inline' }}
            localizedValue={remainingBalanceLocalized}
            value={remainingBalance}
            suffix={currency}
          />
          <div
            className={classes.addButton}
            data-disabled={disableButtons || isRemainingBalanceSaturated || undefined}
            onClick={() => {
              handleSetAmount(item.id, String(remainingBalance));
            }}
          >
            <Icon size="12px" name={IconName.PLUS} />
          </div>
        </div>
      </td>
      <td>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Amount
            style={{ display: 'inline' }}
            localizedValue={remainingFeesLocalized}
            value={Number(remainingBalance) + Number(remainingFees)}
            suffix={currency}
          />
          <div
            className={classes.addButton}
            data-disabled={disableButtons || isRemainingBalanceWithFeesSaturated || undefined}
            onClick={() => {
              handleSetAmount(item.id, String(Number(remainingBalance) + Number(remainingFees)));
            }}
          >
            <Icon size="12px" name={IconName.PLUS} />
          </div>
        </div>
      </td>
      <td>
        <input
          className={classes.amountInput}
          type="number"
          value={amount === '' ? amount : Number(amount)}
          onChange={val => handleSetAmount(id, val.target.value)}
        />
      </td>
    </tr>
  );
};
